<!-- Timetable.vue
  座席予約表を表示するコンポーネント
-->
<template lang="html">
  <div id="timetable" :style="getStyle">
    <span v-if="$store.state.modal.trigger">

      <marquee bgcolor="#000000"><font color="#ffffff"><a v-html="$store.state.modal.text"></a></font></marquee>
    </span>
    <timetable-header></timetable-header>
    <timetable-body></timetable-body>
    <refresh-button></refresh-button>
  </div>
</template>

<script>
import TimetableHeader from './TimetableHeader'
import TimetableBody from './TimetableBody'
import RefreshButton from './RefreshButton'
import {
  mapActions,
  mapGetters
} from 'vuex'
import axios from 'axios'
export default {
  name: 'timetable',
  props: [
  ],
  data () {
    return {
      style: {}
    }
  },
  components: {
    'timetable-header': TimetableHeader,
    'timetable-body': TimetableBody,
    'refresh-button': RefreshButton
  },
  computed: {
    ...mapGetters([
      'tableWidth',
      'getCurDateFormated'
    ]),
    getStyle () {
      this.style.width = this.tableWidth + 'px'
      return this.style
    }
  },
  methods: {
    ...mapActions([
      'getReservations',
      'getLectures',
      'getClassrooms',
      'getAttendance'
    ])
  },
  mounted () {
    axios.all([
      this.getReservations({
        all: 1,
        date: this.getCurDateFormated,
        school_id: this.$store.state.userInfo.school_id
      }),
      this.$store.dispatch('getLectures', {}),
      this.$store.dispatch('getUserInfo')
    ]).then(axios.spread((res1, res2, res3) => {
      if (this.$store.state.userInfo.user_type === 'admin') {
        this.$store.dispatch('getAttendance')
      }
    })).then(() => {
      this.getClassrooms(this.$store.state.userInfo.school_id)
    })
  },
  created () {
    this.getClassrooms(this.$store.state.userInfo.school_id)
  }
}
</script>

<style lang="css">
div#timetable {
  border-collapse: collapse;
  border-style: solid;
  border-width: 2px;
  box-sizing: border-box;
  margin: auto;
}
</style>



// WEBPACK FOOTER //
// Timetable.vue?c7714c68